// Вырезает фрагмент изображения по нормализованному bbox через <canvas>.
// box: { x, y, w, h } — доли 0..1 от ширины/высоты исходного изображения.
// Возвращает data-URI (image/png) вырезанного фрагмента или null при ошибке.

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error("Не удалось загрузить изображение для вырезки"))
    img.src = src
  })

// Ограничивает значение диапазоном [min, max]
const clamp = (value, min, max) => Math.min(max, Math.max(min, value))

// objectUrl — URL.createObjectURL(file) исходного фото меню
export const cropImageByBox = async (objectUrl, box) => {
  if (!objectUrl || !box) return null

  try {
    const img = await loadImage(objectUrl)
    const iw = img.naturalWidth
    const ih = img.naturalHeight

    // Переводим доли в пиксели и подрезаем под границы изображения
    const sx = clamp(box.x * iw, 0, iw)
    const sy = clamp(box.y * ih, 0, ih)
    const sw = clamp(box.w * iw, 1, iw - sx)
    const sh = clamp(box.h * ih, 1, ih - sy)

    if (sw < 2 || sh < 2) return null

    const canvas = document.createElement("canvas")
    canvas.width = Math.round(sw)
    canvas.height = Math.round(sh)
    const ctx = canvas.getContext("2d")
    ctx.drawImage(img, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height)

    return canvas.toDataURL("image/png")
  } catch (error) {
    console.error("cropImageByBox error:", error)
    return null
  }
}
